import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-clickable-card-overlay',
  templateUrl: './clickable-card.component.html',
  styleUrls: ['./clickable-card.component.scss']
})
export class ClickableCardOverlayComponent {
  @Input() hint = '';
  @Input() visible = false;
}
